var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagonal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 100,
    y2: 0,
    strokeWidth: 1,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagonal);
export default __webpack_public_path__ + "static/media/diagonal.809d1d147793962a2cc5609efd0bf8e3.svg";
export { ForwardRef as ReactComponent };